<div id="offlineDonationBulk" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row">
            <div class="col">
                <h4 class="h6 font-weight-bold">Instructions</h4>
                <div class="row">
                    <div class="col">
                        <small>
                            1. Download empty sample File (<a href="/files/sample_paybee_bulk.xlsx">Download</a>)<br>
                            2. Add required and optional data <br>
                            <div class="d-flex align-items-center">
                                <span class="mr-1">3. Campaign id lookup </span>
                                <i class="fas fa-long-arrow-alt-right fa-2x"></i>
                            </div>
                            4. Upload file, fix any issues reported <br>
                            5. Submit<br>
                            <b>6. Do not change the column headers names.</b>
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <a id="instructionsHide" class="blue-text" style="font-size: small;text-decoration: underline;" onclick="orgMain.showHideInstructions()">Show Detailed instructions</a>
                    </div>
                </div>
            </div>
            <div class="col">
                <h4 class='h6 font-weight-bold'>Campaign ID lookup</h4>
                <fieldset class="form-group noMargin caret-up" id="campaignLookupFS">
                </fieldset>
                <small id="lookedUpIdName"></small><br>
                <p id="lookedUpId"></p>
            </div>
        </div>
        <div id="offlineInstructions" style="display: none">
            <div class="row align-items-center" style="margin-bottom: 1rem;">
                <div class="col"><b>Supported File Format:</b> XL spreadsheet with header row</div>
            </div>
            <table class="table table-bordered table-sm">
                <thead>
                <tr>
                    <th scope="col">Column Name</th>
                    <th scope="col">Header</th>
                    <th scope="col">Value</th>
                    <th scope="col">Description</th>
                    <th scope="col">Note</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>name*</td>
                    <td><small>Required</small></td>
                    <td><small>Required</small></td>
                    <td><small>Name of Donor</small></td>
                    <td><small>Full name of Donor</small></td>
                </tr>
                <tr>
                    <td>email*</td>
                    <td><small>Required</small></td>
                    <td><small>Optional</small></td>
                    <td><small>Email of Donor</small></td>
                    <td><small>One of Email, Phone or Address must be present</small></td>
                </tr>
                <tr>
                    <td>phone*</td>
                    <td><small>Required</small></td>
                    <td><small>Optional</small></td>
                    <td><small>US phone number of Donor</small></td>
                    <td><small>One of Email, Phone or Address must be present</small></td>
                </tr>
                <tr>
                    <td>address*</td>
                    <td><small>Required</small></td>
                    <td><small>Optional</small></td>
                    <td><small>Full street of the Donor</small></td>
                    <td><small>One of Email, Phone or Address must be present</small></td>
                </tr>
                <tr>
                    <td>campaign_id*</td>
                    <td><small>Required</small></td>
                    <td><small>Required</small></td>
                    <td><small>Campaign Id, number</small></td>
                    <td><small>Use campaign Id lookup to find correct values</small></td>
                </tr>
    
                <tr>
                    <td>amount*</td>
                    <td><small>Required</small></td>
                    <td><small>Required</small></td>
                    <td><small>Donation amount in dollars, excel cell type is number or currency</small></td>
                    <td><small>Non zero donation amount</small></td>
                </tr>
                <tr>
                    <td>date</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>Donation date in Month date, year (e.g. March 30, 2018), change excel cell type to text </small></td>
                    <td><small>Current date will be used if not present</small></td>
                </tr>
                <tr>
                    <td>memo</td>
                    <td><small>Optional</small></td>
                    <td><small>Optional</small></td>
                    <td><small>Any additional notes</small></td>
                    <td><small>Any additional notes about this donation</small></td>
                </tr>
                <tr>
                    <td>method</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>Donation Method - use "check", "cash", "card", "inkind", "stock" or "other"</small></td>
                    <td><small>If Empty defaults to check</small></td>
                </tr>
                <tr>
                    <td>type</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>use donation or corpmatch</small></td>
                    <td><small>Defaults to donation if not present</small></td>
                </tr>
                <tr>
                    <td>company</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>Donation matching company</small></td>
                    <td><small>Only used when donation type is corpmatch</small></td>
                </tr>
                <tr>
                    <td>notify</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>Notify donor of donation - yes or no</small></td>
                    <td><small>Notification sent via email if present</small></td>
                </tr>
                <tr>
                    <td>inKindDescription</td>
                    <td><small>optional</small></td>
                    <td><small>optional</small></td>
                    <td><small>Option description for in kind donations</small></td>
                    <td><small>Option description for in kind donations.</small></td>
                </tr>
                </tbody>
            </table>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <form>
                    <div class="form-row">
                        <div class="md-form">
                            <div class="file-field" style="width: 25rem;">
                                <div class="btn btn-primary btn-sm float-left">
                                    <span>Choose file</span>
                                    <input id="offlineBulkFile" type="file" accept=".xlsx">
                                </div>
                                <div class="file-path-wrapper">
                                    <input id="offlineBulkFileSelected" class="file-path validate" type="text" placeholder="Selected File">
                                </div>
                            </div>
                        </div>
                        <div class="md-form">
                            <a class="btn-floating purple-gradient mt-0 float-left" id="uploadOfflineButton">
                                <i class="fas fa-cloud-upload-alt"></i>
                            </a>
                        </div>
                    </div>
                    <p id="offlineUploadError" class="red-text"></p>
                </form>
            </div>
        </div>
        <hr>
        <div id="reviewOfflineData" style="display: none">
            <h4> Review Donation Data</h4>
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">Action</th>
                    <th scope="col">Donor</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Date</th>
                    <th scope="col">Campaign/Option</th>
                    <th scope="col">Type/Method</th>
                    <th scope="col">Notify</th>
                    <th scope="col">Memo</th>
                    <th scope="col">InKind Item</th>
                </tr>
                </thead>
                <tbody id="reviewOfflineTable">
                </tbody>
            </table>
            <div class="row justify-content-center">
                <div class="col text-center">
                    <a  class="btn btn-success"
                        onclick="orgMain.validateBulkDonation()"
                        id="addOfflineBulkDonationButton"
                        style="margin-top: 2rem; margin-bottom: 2rem;"
                    >Add Donations</a>
                </div>
            </div>
        </div>
        <div id="offlineUploadSuccess" class="text-center" style="display: none; margin-top: 3rem">
            <h4>Donations successfully added! </h4>
        </div>
    </div>
</div>